import { useCallback } from 'react';

import type { RefObject } from 'react';

export const useScrollToTop = <Ref extends RefObject<HTMLElement>>(ref: Ref) =>
  useCallback(
    () => ref.current?.scrollTo({ top: 0, behavior: 'smooth' }),
    [ref],
  );
